import { forwardRef, type Ref, type SVGProps } from "react";
const IconCatFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.017 28.405h.018a12.73 12.73 0 0 0 8.08-2.905l1.48 1.48a.954.954 0 0 0 1.35-1.349l-1.45-1.45q.649-.718 1.185-1.53l1.691 1.692a.954.954 0 1 0 1.35-1.349l-2.08-2.08a12.7 12.7 0 0 0 1.145-5.295v-.654a1 1 0 0 0-.016-.175l-1.584-9.02c-.335-1.91-2.556-2.807-4.123-1.664l-4.064 2.963a.7.7 0 0 1-.419.136h-5.125a.7.7 0 0 1-.42-.136L8.973 4.106c-1.567-1.143-3.788-.247-4.124 1.663l-1.584 9.02q-.015.088-.015.176v.654c0 1.88.406 3.664 1.134 5.272L2.28 22.994a.954.954 0 0 0 1.35 1.35l1.71-1.714q.535.812 1.182 1.532L5.054 25.63a.954.954 0 1 0 1.35 1.35L7.9 25.483a12.73 12.73 0 0 0 8.1 2.921zM11.975 16.14a1.388 1.388 0 1 0 0-2.776 1.388 1.388 0 0 0 0 2.776m9.507-1.388a1.388 1.388 0 1 1-2.776 0 1.388 1.388 0 0 1 2.776 0m-7.009 3.487a.954.954 0 1 0 0 1.908h.564a1.37 1.37 0 0 1-1.362 1.214.954.954 0 0 0 0 1.909A3.27 3.27 0 0 0 16 22.303a3.27 3.27 0 0 0 2.325.967.954.954 0 1 0 0-1.909 1.37 1.37 0 0 1-1.362-1.214h.598a.954.954 0 0 0 0-1.908z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconCatFilledSVG);
ForwardRef.displayName = "IconCatFilled";
export { ForwardRef as IconCatFilled };
